<template>
  <footer class="footer">
    <div class="container custom-container">
      <div class="columns">
        <div class="column is-one-fifth">
          <figure class="image-logo">
            <img :src="logo" alt="SelCorp - Sistema Eletrônico de Licitações" />
          </figure>
        </div>
        <div class="column is-one-fifth">
          <h1 class="custom-title">Pesquisa</h1>
          <div class="item-list">
            <router-link :to="{ name: 'ItemPesquisa' }" class="item-link"> Itens </router-link>
          </div>
        </div>

        <div class="column is-one-fifth">
          <h1 class="custom-title">Licitações</h1>

          <div class="item-list">
            <router-link :to="{ name: 'Licitacoes' }" class="item-link">Licitações</router-link>
          </div>
        </div>

        <div class="column is-one-fifth">
          <h1 class="custom-title">Recursos</h1>

          <div class="item-list">
            <router-link :to="{ name: 'Manuals' }" tag="a" class="item-link">Manuais</router-link>
          </div>

          <div class="item-list">
            <router-link :to="{ name: 'MainContractPoints' }" tag="a" class="item-link"
              >Contrato de Serviço</router-link
            >
          </div>
        </div>

        <div class="column is-one-fifth">
          <h1 class="custom-title">Sobre</h1>
          <div class="item-list">
            <router-link :to="{ name: 'SobreNos' }" class="item-link"> Quem Somos </router-link>
          </div>
          <div class="item-list">
            <div class="item-content">
              <b-icon class="custom-icon" icon="whatsapp" type="is-success" />
              <strong>(14) 9 9164-9190</strong>
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr class="separator" />
    <div class="content has-text-centered custom-content">
      <iframe
        src="https://status.selcorp.com.br/badge?theme=light"
        title="Status do sistema"
        class="status-badge"
        width="250"
        height="30"
        loading="lazy"
      />
      <div class="item-content">
        Suporte técnico das 8h às 17h30 horas (horário de Brasília) em dias úteis, de segunda à
        sexta-feira.
      </div>
      <div class="item-content">
        O prazo para validação de cadastros é de, no mínimo, 24 horas após a solicitação realizada
        pelas licitantes.
      </div>
    </div>

    <hr class="separator" />
    <div class="content has-text-centered custom-content">
      <p>
        <a href="http://www.selcorp.com.br">SelCorp</a> - Sistema Eletrônico de Licitações.
        Copyright (C) {{ new Date().getFullYear() }}. Versão: {{ version }}.
      </p>
    </div>
  </footer>
</template>

<script>
import logo from '@/assets/logosel.png';

export default {
  name: 'TheFooting',
  data() {
    return {
      version: process.env.VUE_APP_VERSION,
      logo,
    };
  },
};
</script>

<style lang="scss" scoped>
.custom-container {
  border: none !important;
  padding: unset !important;
  width: 80%;
}

.custom-content {
  font-size: 0.96rem;
  margin: 0 10px;
}

.custom-icon {
  margin-right: 0.2rem;
  vertical-align: middle;
}

.custom-title {
  font-size: 0.96rem;
  font-weight: 900;
  margin-bottom: 1rem;
}

.footer {
  background-color: #ececec !important;
  padding: 2rem 0 4.5rem !important;
}

.image-logo {
  width: 80%;
}

.item-content {
  color: rgb(77, 77, 77);
}

.item-link {
  color: rgb(77, 77, 77);
}

.item-link:hover {
  text-decoration: underline;
}

.item-list {
  font-size: 0.92rem;
  margin-bottom: 0.8rem;
}

.separator {
  background-color: rgb(216, 216, 216);
  height: 1px;
}

// Tamanho fixo no CSS: o `iframe { height: 50vh }` sem scoped de AuctionContainer
// e DispensaItem vaza para o app todo e esticaria o badge.
.status-badge {
  border: none;
  color-scheme: normal;
  display: block;
  height: 30px;
  margin: 0 auto 0.5rem;
  max-width: 100%;
  width: 250px;
}

@media (max-width: 800px) {
  .custom-content {
    font-size: 0.78rem;
  }

  .image-logo {
    width: 40%;
    margin-bottom: 0.8rem;
  }
}

@media (min-width: 1500px) {
  .custom-container {
    width: 70%;
  }

  .image-logo {
    width: 70%;
  }
}
</style>
